import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fade } from '../private/components/fade/Fade';
import { ModalBase } from '../modal/ModalBase';
import { SwipeableDrawer } from './SwipeableDrawer';
import { PositionedDrawer } from './PositionedDrawer';
import { useBreakpoint } from '../hooks/useBreakpoint';
import HTMLElementType from '../private/utils/HTMLElementType';

const Drawer = React.forwardRef((props, ref) => {

  const {
    container,
    open,
    onClose,
    fixed,
    position,
    children
  } = props;

  const screen = useBreakpoint('md');
  const isSmall = screen.lesser;

  const gridClasses = classNames('sui-h-full sui-outline-none', {
    'landscape:sui-grid landscape:sui-grid-cols-12 landscape:sui-gap-4': isSmall,
    'sui-grid sui-grid-cols-12 sui-gap-4': !isSmall
  });

  return (
    <ModalBase
      open={open}
      onClose={onClose}
      ref={ref}
      container={container}
    >
      <Fade in={open} classes={gridClasses}>
        {isSmall && (
          <SwipeableDrawer fixed={fixed}>
            {children}
          </SwipeableDrawer>
        )}
        {!isSmall && (
          <PositionedDrawer position={position}>
            {children}
          </PositionedDrawer>
        )}
      </Fade>
    </ModalBase>
  );
});

Drawer.displayName = 'Drawer';

Drawer.propTypes = {
  /**
   * @ignore
   */
  container: PropTypes.oneOfType([
    HTMLElementType,
    PropTypes.func,
  ]),
  /**
   * Drawer children, usually the included sub-components.
   */
  children: PropTypes.node,
  /**
   * If true, the drawer is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Function to handle a close event for drawer.
   */
  onClose: PropTypes.func,
  /**
   * Placement of the drawer.
   */
  position: PropTypes.oneOf(['left', 'right']),
  /**
   * Prop passed to SwipeableDrawer and adds a max-height 50%, min-height 50%, and height 50% to drawer.
   */
  fixed: PropTypes.bool
};

Drawer.defaultProps = {
  position: 'right',
  fixed: false,
};

export { Drawer };